import type { IUserSignUpData } from 'api/types/user';

export enum SignUpSteps {
    STEP_ONE = 'emailValidation',
    STEP_TWO = 'basicInfo',
    STEP_THREE = 'brokerDetails',
    STEP_FOUR = 'location',
    STEP_SIX = 'passwordCreation', // Used only for step count
    STEP_SEVEN = 'subscription', // Used only for step count
}

export const STEP_COUNT = Object.keys(SignUpSteps).length;

export type IEmailForm = Pick<IUserSignUpData, 'email'>;

export type IContactForm = {
    email: string;
    phone: string;
};

export type ContactErrors = {
    email?: string;
    phone?: string;
};

export type IAccountDetailsForm = Pick<
    IUserSignUpData,
    'age' | 'gender' | 'firstName' | 'lastName'
>;

export type ILocationForm = Pick<IUserSignUpData, 'zip' | 'state'>;

export type IBrokerDetailForm = Pick<
    IUserSignUpData,
    | 'brokerageLicenseNumber'
    | 'brokerageName'
    | 'housesSold'
    | 'averageHomeValue'
    | 'yearsExperience'
>;
